// DOP-925: event queue + batch sender — nguyên tắc spec: không gọi đồng bộ,
// không block UI, chạy nền, lỗi mạng nuốt im lặng (fire-and-forget).
import { TrackingEvent } from "./types"

const FLUSH_INTERVAL_MS = 5000
const FLUSH_MAX_BATCH = 10

const TRACKING_ENDPOINT = `${process.env.NEXT_PUBLIC_API_BASE}/tracking/v1/events`
const IS_DRYRUN = process.env.NEXT_PUBLIC_TRACKING_DRYRUN === 'true'

let queue: TrackingEvent[] = []
let flushTimer: ReturnType<typeof setInterval> | null = null

const send = (events: TrackingEvent[]) => {
  if (IS_DRYRUN) {
    // eslint-disable-next-line no-console
    console.debug('[tracking:dryrun]', events)
    return
  }

  const token = localStorage.getItem('apiAccessToken')
  // keepalive: request sống sót qua unload/chuyển trang (thay cho sendBeacon,
  // vẫn gửi được Authorization header)
  fetch(TRACKING_ENDPOINT, {
    method: 'POST',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ events }),
  }).catch(() => {
    // fire-and-forget: không retry, không toast — tracking không được ảnh hưởng UX
  })
}

export const flush = () => {
  if (!queue.length) return
  const events = queue
  queue = []
  send(events)
}

export const enqueue = (event: TrackingEvent) => {
  queue.push(event)
  if (queue.length >= FLUSH_MAX_BATCH) {
    flush()
    return
  }
  if (!flushTimer) {
    flushTimer = setInterval(flush, FLUSH_INTERVAL_MS)
  }
}

let listenersInitialized = false

/** Gắn listener flush khi rời trang/ẩn tab — gọi 1 lần từ TrackingProvider. */
export const initTrackingFlushListeners = () => {
  if (listenersInitialized || typeof window === 'undefined') return
  listenersInitialized = true

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
  // pagehide cover cả mobile Safari (không bắn beforeunload khi bfcache)
  window.addEventListener('pagehide', flush)
}
